/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editOutboundConfig.vue?vue&type=template&id=5cd2306d&scoped=true"
import script from "./editOutboundConfig.vue?vue&type=script&lang=js"
export * from "./editOutboundConfig.vue?vue&type=script&lang=js"
import style0 from "./editOutboundConfig.vue?vue&type=style&index=0&id=5cd2306d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd2306d",
  null
  
)

export default component.exports